import axios from "axios";
import $store from "../store";
import context from '../main';



const instance = axios.create({
    baseURL: '/', //http://dxm87.zihai.shop
    // baseURL: '/api',
    timeout: 1000 * 300, //5分钟响应时间
});



export default function request(url, method, data = {}) {
    const token = $store.state.token;
    // console.log(111,token,url);
    data.token = token;
    let headers = {};

    return instance({
        url,
        method,
        headers,
        data,
    }).then(res => {
        // console.log(res.data);
        if(res.data.code == 200){
            return Promise.resolve(res.data);
        }else if(res.data.code == 300){
            context.$alert(res.data.msg, {
                confirmButtonText: '确定',
                callback: action => {
                    localStorage.clear();
                    window.location.href='/';
                }
            });
            return Promise.reject(res.data);
        }else{
            context.$alert(res.data.msg);
            return Promise.reject(res.data);
        }

        // if (res.status !== 200)
        //     return Promise.reject({ msg: "请求失败", res, data });

        // if ([410000, 410001, 410002].indexOf(data.status) !== -1) {
        //     toLogin();
        //     return Promise.reject({ msg: res.data.msg, res, data, toLogin: true });
        // } else if (data.status === 200) {
        //     return Promise.resolve(data, res);
        // } else {
        //     return Promise.reject({ msg: res.data.msg, res, data });
        // }
    });
}


['options', 'get', 'post', 'put', 'head', 'delete', 'trace', 'connect'].forEach((method) => {
    request[method] = (url, data) => request(url, method, data)
});


// WEBPACK FOOTER //
// ./src/utils/request.js